// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","InfoTooltip__trigger":"bcm_a bic_jb bic_qx bic_eg"};